import contract from '@mailobj-browser/front/js/contracts/contract.js'
import addEdit from './addEdit/addEdit.js'
import resource from './resource/resource.js'

export default contract({
  addEdit,
  resource
})